var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowEntry({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#F0F5F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4769 5.67578H34V34.3216H16.4769V5.67578Z",
    fill: "#D3F8F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8129 5.67578L15.8129 13.3147H16.4769V6.01953L33.336 6.01953V33.9779H16.4769L16.4769 26.6827H15.812V34.3216C15.812 34.5116 15.9605 34.6654 16.144 34.6654H33.668C33.8515 34.6654 34 34.5116 34 34.3216V5.67578C34 5.48576 33.8515 5.33203 33.668 5.33203L16.1449 5.33203C15.9614 5.33203 15.8129 5.48576 15.8129 5.67578Z",
    fill: "#030712"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.6549L6 20.3424L27.3329 20.3424L22.3665 25.4853L22.835 25.9704L28.6038 19.9987L22.835 14.026L22.3665 14.513L27.3329 19.6549L6 19.6549Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowEntry);
export default __webpack_public_path__ + "static/media/ic-arrow-entry.b69f98982b812d855e360c77f3b784cf.svg";
export { ForwardRef as ReactComponent };